// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--3zkej";
export var btn__third = "Button-module--btn__third--1fhwE";
export var btn__secondary = "Button-module--btn__secondary--2k8QP";
export var btn__primary = "Button-module--btn__primary--2r61j";